import React from 'react';
import IconArrow from '../../_svg/arrow.svg';

function Button(props) {
	
	return (
		<React.Fragment>
			<a className={`${props.cssClass} button`} href={props.url}>
				<span className="button__label">{props.label}</span>
				<figure className="button__ico ui-ico">
					<IconArrow />
				</figure>
			</a>
		</React.Fragment>
	);
}	

export default Button;